export default {
    bind(el) {

        el.addEventListener('focus', () => {   // 포커스 될때
            el.style.color = '#1e1e1e';
        });
        el.addEventListener('blur', () => {  // 포커스 잃을때 
           
        });
        el.addEventListener('input', () => {  // 입력중일때 
            el.style.color = '#1e1e1e';
        });
    },
    unbind(el) {
        el.removeEventListener('focus', () => {  // 포커스될 때
            el.style.color = '#1e1e1e';
        });
        el.removeEventListener('blur', () => {  // 포커스 잃을 때 

        });
        el.removeEventListener('input', () => {  // 입력중 일 때 
            el.style.color = '#1e1e1e';
        });
    },
}


// WEBPACK FOOTER //
// ./src/components/directives/focusInputCard.js